var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "supplierSelfEvaluation" },
    [
      _c(
        "el-row",
        [
          _vm.templateList != null && _vm.templateList.length > 0
            ? _c("PickupPlantMulti", {
                attrs: {
                  disabled: _vm.disabled,
                  "five-bit-code": _vm.fiveBitCode,
                  categoryLevel1Code: _vm.fiveBitCodeObj.categoryLevel1Code,
                  categoryLevel2Code: _vm.fiveBitCodeObj.categoryLevel2Code,
                  categoryLevel3Code: _vm.fiveBitCodeObj.categoryLevel3Code,
                  fiveBitCodeName: _vm.fiveBitCodeObj.fiveBitCodeName,
                },
                on: { "pick-up": _vm.addPlant },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "tableForm",
          staticStyle: { "margin-top": "20px" },
          attrs: { model: _vm.tableHeadData },
        },
        [
          _c(
            "el-table",
            {
              ref: "scoreTable",
              attrs: {
                data: _vm.templateList,
                border: "",
                "row-key": "templateDetailId",
                "max-height": "700",
                "span-method": _vm.spanMethod,
                "row-class-name": _vm.rowClassNameFun,
                "cell-class-name": _vm.cellClassNameFun,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("sensory.template.detailName"),
                  fixed: "left",
                  prop: "title",
                  width: "160",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("sensory.template.criterion"),
                  "class-name": "template-detail",
                  "min-width": "500px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.detailType == "TITLE"
                          ? _c("div", [_vm._v(_vm._s(scope.row.detail))])
                          : scope.row.detailType == "SCORE"
                          ? _c("div", [_vm._v(_vm._s(scope.row.detail))])
                          : _c("div", [
                              scope.row.isComments == "Y"
                                ? _c("div", [_vm._v(_vm._s(scope.row.detail))])
                                : _vm._e(),
                              scope.row.isComments != "Y"
                                ? _c(
                                    "div",
                                    [
                                      _vm._l(9, function (i) {
                                        return _c(
                                          "div",
                                          {
                                            key: i,
                                            staticClass:
                                              "template-detail-cell row1",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.detail.split("`")[
                                                    i - 1
                                                  ] == ""
                                                    ? " 　"
                                                    : scope.row.detail.split(
                                                        "`"
                                                      )[i - 1]
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }),
                                      _c(
                                        "div",
                                        _vm._l(9, function (i) {
                                          return _c(
                                            "div",
                                            {
                                              key: i,
                                              staticClass:
                                                "template-detail-cell row2",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.start > i ||
                                                      scope.row.end < i
                                                      ? " "
                                                      : i
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.tableHeadData, function (plant, plantIndex) {
                return _c(
                  "el-table-column",
                  {
                    key: "plant" + plantIndex,
                    attrs: { "header-align": "center", "min-width": "600px" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("pickup-plant", {
                                staticStyle: {
                                  "vertical-align": "middle",
                                  width: "calc(100% - 30px)",
                                },
                                attrs: {
                                  "five-bit-code": _vm.fiveBitCode,
                                  disabled:
                                    _vm.disabled || plant.status == "SUBMIT",
                                  plantName:
                                    _vm.tableHeadData[plantIndex].plantName,
                                },
                                on: {
                                  "update:plantName": function ($event) {
                                    return _vm.$set(
                                      _vm.tableHeadData[plantIndex],
                                      "plantName",
                                      $event
                                    )
                                  },
                                  "update:plant-name": function ($event) {
                                    return _vm.$set(
                                      _vm.tableHeadData[plantIndex],
                                      "plantName",
                                      $event
                                    )
                                  },
                                  "pick-up": function ($event) {
                                    return _vm.changePlant($event, plantIndex)
                                  },
                                },
                                model: {
                                  value:
                                    _vm.tableHeadData[plantIndex].plantName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.tableHeadData[plantIndex],
                                      "plantName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "tableHeadData[plantIndex].plantName",
                                },
                              }),
                              !_vm.disabled
                                ? _c("el-button", {
                                    staticClass: "miniButton",
                                    attrs: {
                                      type: "danger",
                                      icon: "el-icon-minus",
                                      circle: "",
                                      size: "mini",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delPlant(plantIndex)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c(
                      "el-table-column",
                      {
                        attrs: { "header-align": "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("sensory.report.batchNo"))
                                      ),
                                    ]
                                  ),
                                  !_vm.disabled
                                    ? _c("el-button", {
                                        staticClass: "miniButton",
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-plus",
                                          size: "mini",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addBatch(plantIndex)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      _vm._l(plant.batches, function (batch, batchIndex) {
                        return _c(
                          "el-table-column",
                          {
                            key: batchIndex,
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "batchesColumn" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "batchNoView",
                                              attrs: {
                                                rules: _vm.batchRules.batchNo,
                                                prop: `[${plantIndex}].batches[${batchIndex}].batchNo`,
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: {
                                                  "vertical-align": "middle",
                                                },
                                                attrs: {
                                                  disabled:
                                                    _vm.disabled ||
                                                    plant.status == "SUBMIT",
                                                },
                                                model: {
                                                  value:
                                                    _vm.tableHeadData[
                                                      plantIndex
                                                    ].batches[batchIndex]
                                                      .batchNo,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.tableHeadData[
                                                        plantIndex
                                                      ].batches[batchIndex],
                                                      "batchNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "tableHeadData[plantIndex].batches[batchIndex].batchNo",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          !_vm.disabled
                                            ? _c("el-button", {
                                                staticClass: "miniButton",
                                                attrs: {
                                                  type: "danger",
                                                  size: "mini",
                                                  icon: "el-icon-minus",
                                                  circle: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delBatch(
                                                      plantIndex,
                                                      batchIndex
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          _vm._l(batch.users, function (user, userIndex) {
                            return _c(
                              "el-table-column",
                              {
                                key: user.ttSensoryClbPlantBatchId,
                                attrs: { "header-align": "center" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "sensory.calibration.user"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          !_vm.disabled
                                            ? _c("el-button", {
                                                staticClass: "miniButton",
                                                attrs: {
                                                  type: "primary",
                                                  icon: "el-icon-plus",
                                                  size: "mini",
                                                  circle: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addUser(
                                                      plantIndex,
                                                      batchIndex
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { align: "center", "min-width": 200 },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              staticStyle: {
                                                "vertical-align": "middle",
                                                width: "calc(100% - 40px)",
                                              },
                                              attrs: {
                                                disabled: !(
                                                  (_vm.action == "SP_EDIT" &&
                                                    plant.status != "SUBMIT") ||
                                                  _vm.action == "CQS_EDIT"
                                                ),
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.userNameTrim(user)
                                                },
                                              },
                                              model: {
                                                value: user.userName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    user,
                                                    "userName",
                                                    $$v
                                                  )
                                                },
                                                expression: "user.userName",
                                              },
                                            }),
                                            !_vm.disabled
                                              ? _c("el-button", {
                                                  staticClass: "miniButton",
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                    icon: "el-icon-minus",
                                                    circle: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delUser(
                                                        plantIndex,
                                                        batchIndex,
                                                        userIndex
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.detailType != "TITLE" &&
                                            scope.row.detailType != "SCORE" &&
                                            scope.row.isComments == "Y"
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                    },
                                                    attrs: {
                                                      prop: `[${plantIndex}].batches[${batchIndex}].users[${userIndex}].scores[${scope.row.ttTemplateDetailId}]`,
                                                      rules:
                                                        _vm.scoreRules.score2,
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      attrs: {
                                                        type: "textarea",
                                                        disabled:
                                                          _vm.disabled ||
                                                          plant.status ==
                                                            "SUBMIT",
                                                        placeholder:
                                                          _vm.scoresPlaceholder(
                                                            _vm.disabled
                                                          ),
                                                      },
                                                      model: {
                                                        value:
                                                          user.scores[
                                                            scope.row
                                                              .ttTemplateDetailId
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            user.scores,
                                                            scope.row
                                                              .ttTemplateDetailId,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "user.scores[scope.row.ttTemplateDetailId]",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            scope.row.detailType != "TITLE" &&
                                            scope.row.detailType != "SCORE" &&
                                            scope.row.isComments != "Y"
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    staticStyle: {
                                                      width: "120px",
                                                      display: "inline-block",
                                                    },
                                                    attrs: {
                                                      autocomplete: "off",
                                                      prop: `[${plantIndex}].batches[${batchIndex}].users[${userIndex}].scores[${scope.row.ttTemplateDetailId}]`,
                                                      rules:
                                                        _vm.scoreRules.score,
                                                    },
                                                  },
                                                  [
                                                    scope.row.detailType !=
                                                      "TITLE" &&
                                                    scope.row.detailType !=
                                                      "SCORE" &&
                                                    scope.row.isComments != "Y"
                                                      ? _c("el-input", {
                                                          staticClass: "score",
                                                          staticStyle: {
                                                            width: "50px",
                                                          },
                                                          attrs: {
                                                            max: scope.row.end,
                                                            min: scope.row
                                                              .start,
                                                            disabled:
                                                              _vm.disabled ||
                                                              plant.status ==
                                                                "SUBMIT",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.tableHeadData[
                                                                plantIndex
                                                              ].batches[
                                                                batchIndex
                                                              ].users[userIndex]
                                                                .scores[
                                                                scope.row
                                                                  .ttTemplateDetailId
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .tableHeadData[
                                                                  plantIndex
                                                                ].batches[
                                                                  batchIndex
                                                                ].users[
                                                                  userIndex
                                                                ].scores,
                                                                scope.row
                                                                  .ttTemplateDetailId,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "tableHeadData[plantIndex].batches[batchIndex].users[userIndex].scores[scope.row.ttTemplateDetailId]",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            scope.row.detailType == "SCORE"
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.countScore(
                                                        scope.row.scoreField,
                                                        user
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("FileUpload", {
        staticStyle: { "margin-top": "20px" },
        attrs: {
          disabled: _vm.disabled,
          "rec-type": "SENSORY_CALIBRATION",
          seq: 1,
          "biz-id": _vm.ttSensoryCalibrationId,
        },
        on: { input: _vm.changeFiles },
        model: {
          value: _vm.subFiles,
          callback: function ($$v) {
            _vm.subFiles = $$v
          },
          expression: "subFiles",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }